// Implements: F-MCK-002
/**
 * Mockup v3 P8: the current version of a gallery mockup, drawn "v8" and read "Versión 8". Nothing at
 * all before the first generation (`null`) or when the listing carries no number: a "v0" would claim
 * a version that does not exist. Pure presentation.
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import { Badge } from "../../../shared/ui/atoms/Badge";
import styles from "./MockupCard.module.css";

export interface VersionBadgeProps {
  readonly number: number | null | undefined;
}

export function VersionBadge({ number }: VersionBadgeProps): ReactElement | null {
  const { t } = useTranslation();
  if (number === null || number === undefined) return null;
  return (
    <Badge tone="neutral">
      <span aria-hidden="true">{t("gallery.versionBadge", { n: number })}</span>
      <span className={styles.srOnly}>{t("gallery.versionBadge.label", { n: number })}</span>
    </Badge>
  );
}
